import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

// ---------------------------------------------------------------------------
// FA Admin v2 theme (restyle step 1 — see docs/FRONTEND_RESTYLE_PLAN.md)
//
// The tagging platform is an internal operations surface (taggers / QC /
// sys-admins), so it wears the Field Agent *agent* brand: orange primary.
// Token values are copied from the canonical FA Admin v2 reference SPAs
// (Collection Review + Suites Manager) via FA-web's ADMIN_RESTYLE_PLAN.md §3.
//
// Multi-tenant override: the primary accent defaults to FA orange but can be
// swapped per tenant at Docker build time via VUE_APP_THEME_PRIMARY (same
// pattern as VUE_APP_SITE_TITLE). Unset → orange, so this works standalone.
//
// options.customProperties exposes every theme color as a CSS var
// (--v-primary-base, --v-tertiary-base, …) so scoped styles and the
// dim-opacity convention can reference the theme instead of hardcoding hexes.
// ---------------------------------------------------------------------------

const BRAND_PRIMARY = process.env.VUE_APP_THEME_PRIMARY || '#FF6A03'

// Semantics + support accents are shared across both brands (FA-web
// BRAND_COLOR_SYSTEM.md §5) and across light/dark.
const SHARED = {
	secondary: '#80A1FF', // periwinkle — alternatives / metadata
	tertiary: '#76005B', //  deep burgundy — edge-case variants
	accent: BRAND_PRIMARY, // = primary
	success: '#018064',
	warning: '#CECD43',
	error: '#A81313',
	info: '#3B6DBC',
}

const opts = {
	theme: {
		dark: false, // light pass first; dark mode is restyle step 5
		options: { customProperties: true },
		themes: {
			light: {
				primary: BRAND_PRIMARY,
				...SHARED,
			},
			dark: {
				primary: BRAND_PRIMARY,
				...SHARED,
			},
		},
	},
}

export default new Vuetify(opts)
